export const LIVE_AUDIO_PREVIEW = {
    activeAudioPreviews: [],
    playStopAudio: (srcUrl) => {
        // Is this audio already playing?
        const existingPreview = LIVE_AUDIO_PREVIEW.activeAudioPreviews.find(
            (preview) => preview.srcUrl === srcUrl
        );
        // Let's stop it if it is
        if (existingPreview) {
            existingPreview.audio.pause();
            existingPreview.audio.currentTime = 0;
            LIVE_AUDIO_PREVIEW.activeAudioPreviews = LIVE_AUDIO_PREVIEW.activeAudioPreviews.filter(
                (preview) => preview.srcUrl !== srcUrl
            );
            return;
        }
        // If we get here then the audio is not playing, so we need to play it...
        // Play the audio and store a reference to the audio element and srcUrl so we can stop it later
        const audio = new Audio(srcUrl);
        LIVE_AUDIO_PREVIEW.activeAudioPreviews.push({ audio, srcUrl });
        const playPromise = audio.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch((error) => {
                console.error('Audio preview failed for source:', srcUrl, error);
                LIVE_AUDIO_PREVIEW.activeAudioPreviews = LIVE_AUDIO_PREVIEW.activeAudioPreviews.filter(
                    (preview) => preview.srcUrl !== srcUrl
                );
            });
        }
        audio.addEventListener('ended', () => {
            LIVE_AUDIO_PREVIEW.activeAudioPreviews = LIVE_AUDIO_PREVIEW.activeAudioPreviews.filter(
                (preview) => preview.srcUrl !== srcUrl
            );
        });
    }
}
